export default __webpack_public_path__ + "static/media/matormoyi.9d2ff9fb.jpg";